module.exports = __webpack_public_path__ + "static/img/no-pingjia.dc2371c6.png";